import { Pipe, PipeTransform } from '@angular/core';
import { leaveLabel } from '../constants/constants';
/*
 * Raise the value exponentially
 * Takes an exponent argument that defaults to 1.
 * Usage:
 *   value | exponentialStrength:exponent
 * Example:
 *   {{ 2 | exponentialStrength:10 }}
 *   formats to: 1024
*/
@Pipe({ name: 'stateCell' })
export class StateCellPipe implements PipeTransform {
  transform(value: string): string {

    let statusLabel = {
      "Headquarter": "cellStyleHeadQuarter",
      "Leave": "cellStyleLeave",
      "Bank Holiday": "cellStyleHoliday",
      "Travel": "cellStyleTravel",
    };

    for (let i in statusLabel){
      if (value == i){
        return statusLabel[i];
      } else if (leaveLabel.indexOf(value) > -1){
        return statusLabel.Leave;
      }
    }

    return statusLabel.Travel;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/state-cell.pipe.ts